module.exports = __webpack_public_path__ + "static/media/produtos-subheader.c3c6935a.jpg";